var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { Icon } from '@frontend_zz/icon/Icon.js';
import { Input } from '../Input/Input.js';
import { UseScopedElements } from '../../mixins/UseScopedElements/index.js';
import styles from './TextInput.css.js';
import { litVisuallyHidden as visuallyHiddenStyle } from '../../shared/styles/utility/misc.css.js';
export const validationTypeOptions = ['success', 'error'];
export const textTransformTypeOptions = ['uppercase', 'lowercase'];
/**
 * @element zz-text-input
 */
export class TextInput extends UseScopedElements(Input) {
    constructor() {
        super(...arguments);
        this.counter = undefined;
        this.max = undefined;
        this.inputMode = 'text';
        this.textTransform = undefined;
        this.validationWithoutIcon = false;
    }
    static get scopedElements() {
        return {
            'zz-icon': Icon,
        };
    }
    static get styles() {
        return [Input.styles, styles, visuallyHiddenStyle];
    }
    onInput(event) {
        super.onInput(event);
        this.updateCounter();
    }
    updated() {
        const counter = this.updateCounter();
        this.counter = counter;
    }
    updateCounter() {
        const counter = this.countChars();
        return counter;
    }
    countChars() {
        const input = this.shadowRoot?.querySelector('.input');
        const inputChars = input?.value.length;
        const { max } = this;
        if (max && inputChars) {
            return max - inputChars;
        }
        return max;
    }
    render() {
        const { onInput, max, counter, disabled, hideLabel, type, name, placeholder, value, id, label, autocomplete, inputMode, } = this;
        const finalId = id || `control-${Math.random().toString().slice(2)}`;
        // HTMLElements
        const counterElement = max ? html `<span class="counter">${counter}</span>` : '';
        return html `
            <label class=${classMap({ 'visually-hidden': hideLabel })} for=${finalId}>${label}</label>
            <div class="container">
                <div class="input-container">
                    <input
                        id=${finalId}
                        class="input"
                        name=${name}
                        placeholder=${ifDefined(placeholder)}
                        maxlength=${ifDefined(max)}
                        .autocomplete=${autocomplete || ''}
                        .inputMode=${inputMode}
                        .value=${value}
                        ?disabled=${disabled}
                        .type=${type}
                        @input=${onInput}
                    />
                    ${counterElement}
                </div>
                ${this.renderValidationIcon()}
            </div>
            <slot name="validation-message"></slot>
            <slot name="description"></slot>
        `;
    }
    renderValidationIcon() {
        const { validation, validationWithoutIcon } = this;
        if (!validation || validationWithoutIcon) {
            return nothing;
        }
        const validationIcon = validation && validation === 'success' ? 'checkCircle' : 'alertTriangle';
        return html `<zz-icon class="icon icon-${validation}" type="${validationIcon}"></zz-icon>`;
    }
}
__decorate([
    property({ type: Number, reflect: false })
], TextInput.prototype, "counter", void 0);
__decorate([
    property({ type: Number, reflect: true })
], TextInput.prototype, "max", void 0);
__decorate([
    property({ type: String, reflect: true })
], TextInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: String, reflect: true })
], TextInput.prototype, "autocomplete", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'inputmode' })
], TextInput.prototype, "inputMode", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'text-transform' })
], TextInput.prototype, "textTransform", void 0);
__decorate([
    property({ reflect: true })
], TextInput.prototype, "validation", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'validation-without-icon' })
], TextInput.prototype, "validationWithoutIcon", void 0);
